import { render, staticRenderFns } from "./budgetTab.vue?vue&type=template&id=7f627d74&scoped=true&"
import script from "./budgetTab.vue?vue&type=script&lang=js&"
export * from "./budgetTab.vue?vue&type=script&lang=js&"
import style0 from "./budgetTab.vue?vue&type=style&index=0&id=7f627d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f627d74",
  null
  
)

export default component.exports